import React from 'react'
import {BiSearchAlt2} from 'react-icons/bi'
import { Posterdata } from './Posterdata'
import Postervideo from './Postervideo'

const Posterfetch = ({setcuerrentVideo,setplaying}) => {
    return (
        <>
          <div className="posterfetch">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-white"> <span><BiSearchAlt2/></span> DISCOVER</h2>
                    </div>
                </div>
        <div className='row'>
            {
                Posterdata.map((val,ind)=>(
                    <Postervideo
                    setplaying={setplaying}
                    setcuerrentVideo={setcuerrentVideo}
                    key={ind}
                    description={val.description}
                    sources={val.sources}
                    subtitle={val.subtitle}
                    thumb={val.thumb}
                    title={val.title}
                    val={val}
                    />
                ))
            }
        </div>
        </div>
        </div>
        </>
    )
}

export default Posterfetch
